import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { NotificationAutoResponseEntity } from './notification-auto-response.entity';
import { NotificationGroupEntity } from './notification-group.entity';
import { NotificationNotificationGroupStateEntity } from './notification-notification-group-state.entity';
import { NotificationEntity } from './notification.entity';
import { PhonePhoneTopicEntity } from './phone-phone-topic.entity';
import { PhoneEntity } from './phone.entity';

@Index('_fk__phone__id', ['fkPhoneId'], {})
@Index('_fk__phone__phone_topic__id', ['fkPhonePhoneTopicId'], {})
@Index('_workd__user__id__active', ['workdUserId', 'active'], {})
@Index(
	'unique_group_member_phone',
	['fkNotificationGroupId', 'fkPhonePhoneTopicId'],
	{ unique: true },
)
@Index('unique_group_member_user', ['workdUserId', 'fkNotificationGroupId'], {
	unique: true,
})
@Entity('_notification_group_member')
export class NotificationGroupMemberEntity extends BaseEntity {
	@Column('int', { name: '_workd__user__id', nullable: true, unsigned: true })
	public workdUserId!: number | null;

	@Column('int', { name: '_fk__phone__id', nullable: true, unsigned: true })
	public fkPhoneId!: number | null;

	@Column('int', { name: '_fk__notification_group__id', unsigned: true })
	public fkNotificationGroupId!: number;

	@Column('varchar', { name: '_role', length: 255, default: () => "'member'" })
	public role!: string;

	@Column({ type: 'boolean', name: '_active', width: 1, default: () => "'0'" })
	public active!: boolean;

	@Column({ type: 'boolean', name: '_mute', width: 1, default: () => "'0'" })
	public mute!: boolean;

	@Column('int', {
		name: '_fk__phone__phone_topic__id',
		nullable: true,
		unsigned: true,
	})
	public fkPhonePhoneTopicId!: number | null;

	@Column('tinyint', {
		name: '_receiveNotification',
		unsigned: true,
		default: () => "'1'",
	})
	public receiveNotification!: number;

	@OneToMany(
		() => NotificationEntity,
		(notification) => notification.fkNotificationGroupMemberIdFrom2,
		{},
	)
	public notifications!: Array<NotificationEntity>;

	@OneToMany(
		() => NotificationNotificationGroupStateEntity,
		(notificationNotificationGroupState) =>
			notificationNotificationGroupState.fkNotificationGroupMember,
		{},
	)
	public notificationNotificationGroupStates!: Array<NotificationNotificationGroupStateEntity>;

	@OneToMany(
		() => NotificationAutoResponseEntity,
		(notificationAutoResponse) =>
			notificationAutoResponse.fkNotificationGroupMemberIdFrom2,
		{},
	)
	public notificationAutoResponses!: Array<NotificationAutoResponseEntity>;

	@ManyToOne(() => PhoneEntity, (phone) => phone.notificationGroupMembers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__phone__id', referencedColumnName: 'id' }])
	public fkPhone!: PhoneEntity;

	@ManyToOne(
		() => NotificationGroupEntity,
		(notificationGroup) => notificationGroup.notificationGroupMembers,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__notification_group__id', referencedColumnName: 'id' },
	])
	public fkNotificationGroup!: NotificationGroupEntity;

	@ManyToOne(
		() => PhonePhoneTopicEntity,
		(phonePhoneTopic) => phonePhoneTopic.notificationGroupMembers,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__phone__phone_topic__id', referencedColumnName: 'id' },
	])
	public fkPhonePhoneTopic!: PhonePhoneTopicEntity;
}
